<div>
  <!-- <h1>{{isNashik ? 'green':'#0369dd'}}</h1>
  <h1>{{isPune ? 'green':'blue'}}</h1>
  <h1>{{isMumbai? 'green':'blue'}}</h1>
  <h1>{{isDelhi? 'green':'blue'}}</h1>
  <h1>{{selectedValue? 'green':'blue'}}</h1> -->
  <app-header></app-header>
  <router-outlet></router-outlet>
</div>